<template>
    <el-header class="app-header common-header" style="background-color: #2E384D;">
        <div class="ch-left">
            <a @click="goHome" class="ch-link">
                <i class="el-icon-arrow-left return-icon"></i>
                <img src="img/logo.png">
            </a>
            <span class="text">{{title}}</span>
        </div>
        <slot name="center"></slot>
        <slot name="right"></slot>
    </el-header>
</template>
<script>
    export default {
        components:{},
        props:{
            title: String,
            routerPath: String,
        },
        methods:{
            goHome(){
                this.$emit('goHome');
                if(this.routerPath){
                    this.$router.push(this.routerPath);
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "./common-header";
</style>